module.exports = __webpack_public_path__ + "static/media/Aeffchen-Illu-Kopf-Blick-nach-oben@3x.f644357f.png";